import { render, staticRenderFns } from "./shopCart.vue?vue&type=template&id=2bec4558&"
import script from "./shopCart.vue?vue&type=script&lang=js&"
export * from "./shopCart.vue?vue&type=script&lang=js&"
import style0 from "./shopCart.vue?vue&type=style&index=0&id=2bec4558&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports